import { Hooks } from 'providers';
import React, { useContext, useEffect, useState } from 'react';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { useOuterClick } from 'providers/OutsideClick';
import 'react-quill/dist/quill.snow.css';
import { useDispatch } from 'react-redux';
import { HIT_ADD_BOARD } from 'redux/actions/board.jsx';
import FormBoard from 'components/board/parts/FormBoard';
import { useTranslation } from 'react-i18next';

function AddBoard() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [state, setState] = React.useState({ value: null });
  const {
    modalAdd, setModal, modal, setModalAdd,
  } = useContext(Hooks);
  const [activeBoard, setActiveBoard] = useState(false);
  const handleChange = (value) => {
    setState({ value });
  };
  const innerRef = useOuterClick((e) => {
    if (modalAdd) {
      setModalAdd(false);
      setModal(false);
    }
  });

  const formik = useFormik({
    initialValues: {
      name: '',
      description: '',
    },
    validationSchema: Yup.object().shape({
      name: Yup.string()
        .typeError('Must string')
        .required('Name cannot empty'),
      description: Yup.string().required('Description cannot empty'),
    }),
    onSubmit: async (values, { resetForm }) => {
      setModalAdd(false);
      setModal(false);
      await dispatch({
        type: HIT_ADD_BOARD,
        payload: {
          name: formik.values.name,
          description: formik.values.description,
          visibility_status: '0',
          publish_status: '3',
        },
      });

      await formik.setValues({
        name: '',
        description: '',
      });
      resetForm();
      formik.values = {};
    },
  });
  useEffect(() => {
    formik.setValues({
      name: '',
      description: '',
      visibility_status: '',
    });
    formik.resetForm();
  }, [modalAdd, modal]);
  return (
    <div
      className={`modal fade rModal ${modalAdd && 'show'}`}
      id="addBoardModal"
      tabIndex="-1"
      role="dialog"
      aria-hidden="true"
    >
      <div className="modal-dialog addboard modal-md" role="document">
        <div className="modal-content" ref={innerRef}>
          <div className="modal-header">
            <h1 className="modal-title float-left">{t('board.create')}</h1>
          </div>
          <div className="modal-body m-2 inline-div">
            <div className="col-12 col-md-12 pr2">
              <FormBoard />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddBoard;
